import { render, staticRenderFns } from "./ListAccount.vue?vue&type=template&id=24b60aee&scoped=true"
import script from "./ListAccount.vue?vue&type=script&lang=js"
export * from "./ListAccount.vue?vue&type=script&lang=js"
import style0 from "./ListAccount.vue?vue&type=style&index=0&id=24b60aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b60aee",
  null
  
)

export default component.exports